export default __webpack_public_path__ + "static/media/notification.4cf0b3c0.svg";